export default __webpack_public_path__ + "95ed52028215235996071b468e37a0ac.svg";